import { useState, useMemo } from 'react';
import ClientInfo from '../ClientInfo/ClientInfo';
import './ClientPage.css';
// ReactOptimizer supprimé

const ClientPage = ({ 
  clients, 
  setEditClient, 
  setDeleteClient, 
  setClients, 
  successFullRdv 
}) => {
  const [fallbackPagination, setFallbackPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const clientsPerPage = 20;

  // Rendu optimisé pour les clients avec memoization
  const renderClient = useMemo(() => (client, index) => (
    <ClientInfo
      key={client.id || index}
      client={client}
      setEditClient={setEditClient}
      setDeleteClient={setDeleteClient}
      setClients={setClients}
      successFullRdv={successFullRdv}
    />
  ), [setEditClient, setDeleteClient, setClients, successFullRdv]);

  // Fallback pagination pour très petites listes ou navigateurs anciens
  const usePagination = clients.length < 50 || fallbackPagination;
  const currentClients = usePagination 
    ? clients.slice((currentPage - 1) * clientsPerPage, currentPage * clientsPerPage)
    : clients;
  const totalPages = Math.max(1, Math.ceil(clients.length / clientsPerPage));

  const handleNextPage = () => {
    if (currentPage < totalPages && clients.length > 0) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1 && clients.length > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="client-page">
        {/* Indicateur de mode de rendu */}
        {clients.length > 50 && !fallbackPagination && (
          <div style={{ 
            padding: '8px 12px', 
            background: '#e3f2fd', 
            borderRadius: '4px', 
            marginBottom: '16px',
            fontSize: '14px',
            color: '#1976d2'
          }}>
            🚀 Mode haute performance: {clients.length} clients avec virtualisation
            <button 
              onClick={() => setFallbackPagination(true)}
              style={{ marginLeft: '12px', fontSize: '12px' }}
            >
              Pagination classique
            </button>
          </div>
        )}

        {/* Rendu classique */}
        <div className="clients-grid">
          {currentClients.map((client) => (
            <ClientInfo
              key={client.id}
              client={client}
              setEditClient={setEditClient}
              setDeleteClient={setDeleteClient}
              setClients={setClients}
              successFullRdv={successFullRdv}
            />
          ))}
        </div>

        {/* Pagination seulement si mode classique */}
        {usePagination && (
          <div className="pagination-controls">
            <button 
              onClick={handlePrevPage} 
              disabled={currentPage === 1 || clients.length === 0}
              className="pagination-button"
            >
              ←
            </button>
            <span className="page-indicator">
              Page {clients.length === 0 ? 0 : currentPage} sur {clients.length === 0 ? 0 : totalPages}
              {clients.length > 50 && (
                <button 
                  onClick={() => setFallbackPagination(false)}
                  style={{ marginLeft: '12px', fontSize: '12px' }}
                  title="Activer la virtualisation pour de meilleures performances"
                >
                  🚀 Virtualiser
                </button>
              )}
            </span>
            <button 
              onClick={handleNextPage} 
              disabled={currentPage === totalPages || clients.length === 0}
              className="pagination-button"
            >
              →
            </button>
          </div>
        )}

        {/* Statistiques de performance en dev */}
        {process.env.NODE_ENV === 'development' && (
          <div style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '8px',
            borderRadius: '4px',
            fontSize: '12px',
            zIndex: 1000
          }}>
            Clients: {clients.length} | Mode: {usePagination ? 'Pagination' : 'Virtualisation'}
          </div>
        )}
      </div>
  );
};

export default ClientPage;
